"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--blue--100,#9ebbff))",
  d: "M3 16.28c0-3.865 1.5-5.705 4-7l2.5 3.295-2.147 3.706zm4-7.205c4-3.425 7.322-1.367 10-.5l-2.5 4.5-5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m7.59 8.622 2.5 3.9-1.18.756-2.5-3.9zm6.32 3.9 2.5-3.9 1.18.756-2.5 3.9z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 8.05a8.6 8.6 0 0 0-8.551 7.676.17.17 0 0 0 .051.144c.044.045.114.08.2.08h2.87c.136 0 .359-.133.435-.453.518-2.179 2.472-3.822 4.815-3.822s4.297 1.643 4.815 3.822c.076.32.298.453.435.453h3.23a.28.28 0 0 0 .2-.08.17.17 0 0 0 .05-.144A8.6 8.6 0 0 0 12 8.05m-9.943 7.527C2.592 10.558 6.839 6.65 12 6.65s9.407 3.908 9.943 8.927c.108 1.013-.727 1.773-1.643 1.773h-3.23c-.968 0-1.618-.775-1.797-1.53-.374-1.571-1.783-2.745-3.453-2.745s-3.08 1.174-3.453 2.746c-.18.754-.829 1.529-1.797 1.529H3.7c-.917 0-1.751-.76-1.643-1.773",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 9.375a.7.7 0 0 0-.7.7v6.5a.7.7 0 1 0 1.4 0v-6.5a.7.7 0 0 0-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterTwoIcon24.js.map